import React from 'react';
import styled from 'styled-components';
import { Body5, Container } from '@ui';
import { TransparentFlatButton } from '@ui/buttons';
import { CloseButton } from '@ui/buttons/CloseButton';
import { ROUTES } from '@constants/routes';

const SelectButtonWrapper = styled.div`
  button {
    padding: 8px 10px;
  }
`;

const DocsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 4px;

  a:hover {
    opacity: 0.8;
  }
`;

export const DocumentSelectorCell = ({ index, docs: selectedDocs, removeDocs, onOpenDocSelect }) => {
  const onOpenDocSelectModal = () => {
    onOpenDocSelect(index);
  };

  const handleDocClick = (doc) => {
    window.open(ROUTES.docViewer + `?id=${doc.id}`, '_blank');
  };

  const handleRemoveDocuments = () => {
    removeDocs(index, null);
  };

  if (!selectedDocs || selectedDocs === null || selectedDocs[0] === null) {
    return (
      <td>
        <SelectButtonWrapper>
          <TransparentFlatButton onClick={onOpenDocSelectModal}>+ Select Docs</TransparentFlatButton>
        </SelectButtonWrapper>
      </td>
    );
  }
  return (
    <td>
      <Container row centerAll spaceBetween>
        <DocsWrapper>
          {selectedDocs.map((doc, i) => (
            <Container key={doc.filename + i}>
              <a onClick={() => handleDocClick(doc)} style={{ cursor: 'pointer' }}>
                <Body5 bold>{doc.filename}</Body5>
              </a>
            </Container>
          ))}
        </DocsWrapper>
        <Container left={8}>
          <CloseButton onClick={handleRemoveDocuments} size={14} />
        </Container>
      </Container>
    </td>
  );
};
